const storeEquipmentService = {
  inactivateSuccess: 'Inactivated equipment service successfully',
  activateSuccess: 'Activated equipment service successfully',
  inactivateError: 'Error inactivating equipment service',
  activateError: 'Error activating equipment service',
}

export default storeEquipmentService;
